import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

const Button = styled.button`
  border: 1px solid ${themeGet('colors.primary')};
  border-radius: ${themeGet('radii.base')};
  color: ${themeGet('colors.primary')};
  display: inline-block;
  font-family: ${themeGet('fonts.heading')};
  font-size: ${themeGet('fontSizes.xxs')};
  letter-spacing: 0.0625rem;
  line-height: 3;
  padding-left: ${themeGet('space.base')};
  padding-right: ${themeGet('space.base')};
  text-decoration: none;
  text-transform: uppercase;

  &:active,
  &:focus,
  &:hover {
    background-color: ${themeGet('colors.primary')};
    color: ${themeGet('colors.light')};
  }
`

export default Button
